import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import ROUTES from '../../../components/Routes/constants';
import Alert from '../../../_shared/components/Alert';
import Trademark from '../../../_shared/components/Trademark';
import TradeInService from '../../../services/TradeInService';
import MixpanelService from '../../../services/MixpanelService';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';

import {
  TiahDetailsContainer,
  TiahDetailsHeading,
  TiahDetailsFormContainer,
  StyledContinueButton
} from '../Styles';
import { ConfirmationNumber, InputBox, MissingCode } from './Styles';
import { VerificationStatus } from '../../../_shared/constants/retail';
import Header from '../../../_shared/components/Header';
import TRToast from '../../../_shared/helpers/TRToast';

const TiahVerification = () => {
  const history = useHistory();
  const intl = useIntl();
  const mixpanel = MixpanelService.get();
  const [confirmNum, setConfirmNum] = useState('    ');
  const confirmNumberRef = useRef();

  const replaceChar = (str, index, char) => {
    return str.substring(0, index) + char + str.substring(index + 1);
  };

  const onInputChange = (inputIndex, value) => {
    let char = value.trim();
    const isNumber = !Number.isNaN(Number(char));
    if (!isNumber && char.length !== 0) {
      return;
    }
    if (char.length === 2) {
      char = char.charAt(1);
    }
    if (char.length === 0) {
      char = ' ';
    }
    const updatedConfirmNum = replaceChar(confirmNum, inputIndex, char);
    setConfirmNum(updatedConfirmNum);
    if (char !== ' ') {
      if (inputIndex < 3 && confirmNum[inputIndex + 1] === ' ') {
        confirmNumberRef?.current.children[inputIndex + 1].focus();
      } else if (inputIndex === 3) {
        confirmNumberRef?.current.children[3].blur();
      }
    }
  };

  const showError = () => {
    TRToast(
      <Alert
        variant="error"
        messages={[<FormattedMessage id="tiah.confirmation.error" />]}
      />
    );
  };

  const handleContinue = async () => {
    function isConfirmNumValid(num) {
      const parsedNum = Number(num);

      return (
        !Number.isNaN(parsedNum) &&
        typeof parsedNum === 'number' &&
        num.trim().length === 4
      );
    }

    if (!isConfirmNumValid(confirmNum)) {
      showError();
    }

    const useTradeInProps = TradeInService.getUserTradeInProps();

    const response = await TradeInService.verifyCode({
      phoneNumber: useTradeInProps?.phoneNumber,
      code: confirmNum.trim(),
      dealerId: useTradeInProps?.dealerId,
      dealerDisplayName: useTradeInProps?.dealerDisplayName
    });

    if (response?.status !== VerificationStatus.APPROVED) {
      showError();
      mixpanel.track(MixpanelConfig.names.tiahError, {
        error_type: 'invalid confirmation code'
      });
      return;
    }

    TradeInService.removeUserTradeInProps();
    mixpanel.track(MixpanelConfig.names.tiahConfirmPhoneNumber, {});

    window.location.replace(
      `${ROUTES.TR4_TRADE_IN}${response?.token}&region=1`
    );
  };

  useEffect(() => {
    const userProps = TradeInService.getUserTradeInProps();

    if (!userProps?.dealerId || !userProps?.dealerDisplayName) {
      TradeInService.removeUserTradeInProps();
      history.push(ROUTES.TIAH);
    }
  });

  return (
    <>
      <Header
        title={intl.formatMessage({ id: 'tiah.confirmation.title' })}
        testId="tiah-verification-header"
        onBackClick={() => history.push(ROUTES.TIAH_MOBILE_NUMBER)}
      />
      <TiahDetailsContainer>
        <TiahDetailsHeading>
          {intl.formatMessage({ id: 'tiah.confirmation.heading' })}
        </TiahDetailsHeading>
        <TiahDetailsFormContainer>
          <div>{intl.formatMessage({ id: 'tiah.confirmation.label' })}</div>
          <ConfirmationNumber ref={confirmNumberRef}>
            {[...Array(4).keys()].map(idx => (
              <InputBox
                key={`confirm-input-box-${idx}`}
                autoFocus={idx === 0}
                type="number"
                inputMode="numeric"
                value={confirmNum[idx] === ' ' ? '' : confirmNum[idx]}
                onChange={e => onInputChange(idx, e.target.value)}
              />
            ))}
          </ConfirmationNumber>
        </TiahDetailsFormContainer>
        <StyledContinueButton onClick={handleContinue}>
          {intl.formatMessage({ id: 'tiah.continue' })}
        </StyledContinueButton>
        <MissingCode onClick={() => history.push(ROUTES.TIAH_MOBILE_NUMBER)}>
          {intl.formatMessage({ id: 'tiah.confirmation.missing' })}
        </MissingCode>
      </TiahDetailsContainer>
      <Trademark />
    </>
  );
};

export default TiahVerification;
